export default __webpack_public_path__ + "static/media/currency.3237ef6c.svg";